import Bouncer from 'formbouncerjs';

const API_DOMAIN = window.wpApiSettings && window.wpApiSettings.api_domain ? window.wpApiSettings.api_domain : 'https://coxoem.com';

const initContactForm = () => {
    let contact_form = document.getElementById('contact-form');

    if(!contact_form) {
        return;
    }

    let rep = getRep();
    
    if(rep) {
        if(document.getElementById('rep-card')) {
            document.getElementById('rep-card').classList.add('show');
        }

        if(document.getElementById('default-form')) {
            document.getElementById('default-form').classList.add('hide');
        }

        if(document.getElementById('rep-name') && rep.name) {
            document.getElementById('rep-name').innerHTML = rep.name;
        }

        if(document.getElementById('rep-email') && rep.email) {
            document.getElementById('rep-email').innerHTML = `
                <a href="mailto:${rep.email}">
                    ${rep.email}
                </a>
            `;
        }

        if(document.getElementById('rep-phone') && rep.phone) {
            document.getElementById('rep-phone').innerHTML = `
                <a href="tel:${rep.phone}">
                    ${rep.phone}
                </a>
            `;
        }
    }

    contact_form.addEventListener('submit', submitForm);
};

const getRep = () => {
    let rep = false;

    if(typeof URLSearchParams === 'undefined') {
        return rep;
    }

    let params = new URLSearchParams(window.location.search);
    let name = params.get('repname');
    let email = params.get('repemail');
    let phone = params.get('repnumber');

    if(name && (email || phone)) {
        rep = {
            name,
            email,
            phone
        }
    }
  
    return rep;
}

const submitForm = (e) => {
    e && e.preventDefault();

    let validation = new Bouncer();
    if (validation.validateAll(e.target).length) {
        return;
    }

    let submit_button = e.target.querySelector('[data-submit-button]');
    submit_button.classList.add('button-loading');
    submit_button.setAttribute('disabled', 'disabled');

    let data = new FormData(e.target);

    let data_object = {};
    data.forEach(function(value, key){
        data_object[key] = value;
    });
    let data_json = JSON.stringify(data_object);
    
    fetch(`${API_DOMAIN}/wp-json/contact-us/submission`, {
		method: 'POST',
        body: data_json
	}).then(function (response) {
		if (response.ok) {
			return response.json();
		}
	}).then(function (data) {
        if(data.confirmation_type === 'redirect' && data.confirmation_redirect) {
            submit_button.classList.remove('button-loading');
            window.location = data.confirmation_redirect;
        }
		else if(data.confirmation_message) {
            e.target.querySelector('[data-confirmation]').innerHTML = data.confirmation_message;
            submit_button.classList.remove('button-loading');
            e.target.reset();

            window.setTimeout(() => {
                submit_button.removeAttribute('disabled');
            }, 4000);
        }
	}).catch(err => {console.log(err)});
}

export default initContactForm;

